export const reportTypes = 
[
    { Id: 0, Name: "Отчет по статусу заказа", Type: orderStateReport },
    { Id: 1, Name: "Популярные услуги", Type: popularServicesOrderTypes },
    { Id: 2, Name: "Популярные клики", Type: popularClicksReport }
];

export const popularServicesOrderTypes = 
[
    { Id: 0, Name: "Количество заказов" },
    { Id: 1, Name: "Сумма заказов" }
];

export function showOrderStateFilter(state) {
    return state === 0 || state.Id === 0;
}

export const orderStateReport = "ORDER_STATE_REPORT";
export const popularServicesReport = "POPULAR_SERVICES_REPORT";
export const popularClicksReport = "POPULAR_CLICKS_REPORT";


// WEBPACK FOOTER //
// ./src/constants/analytics.js